'use strict';
var focusHelper = require('../components/focus');
var pdpCarousel = require('../components/pdpCarousel');

const { notifyMeButton, notifyMeForm } = require('./backInStock');

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else if ($('#editProductModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Handles responsive banner link switching (desktop / mobile)
 */
function initPlpBannerLinkSwitch() {
    var $bannerLink = $('.plp-banner__link');

    if (!$bannerLink.length) {
        return;
    }

    var desktopHref = $bannerLink.attr('href');
    var mobileHref = $bannerLink.data('mobile-link');

    if (!mobileHref) {
        return;
    }

    var mq = window.matchMedia('(max-width: 544px)');

    var updateHref = function () {
        if (mq.matches) {
            $bannerLink.attr('href', mobileHref);
        } else {
            $bannerLink.attr('href', desktopHref);
        }
    };

    updateHref();

    // React on resize / orientation change
    if (mq.addEventListener) {
        mq.addEventListener('change', updateHref);
    } else {
        mq.addListener(updateHref); // Safari fallback
    }
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.addClass('disabled');
        }
    });
}

/**
 * Process attribute values associated with size attribute
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processSizeValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('data-url', attrValue.url).removeAttr('disabled').removeClass('disabled');

        if (attrValue.selected) {
            $attrValue.addClass('selected');
        } else {
            $attrValue.removeClass('selected');
        }

        if (!attrValue.selectable) {
            $attrValue.addClass('disabled');
        }
        if (!attrValue.notifyMe) {
            $attrValue.addClass('notify-me');
        } else {
            $attrValue.removeClass('notify-me');
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else if (attr.id === 'size') {
            processSizeValues(attr, $productContainer);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
	// Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {Object[]} thumbnails - Array of small product images,along with related information
 * @param {Object[]} fullImages - Array of full product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {string} productVideoURL - URL of the video to bbe displayed on PDP
 * @param {string} productVideoPosition - Position of the video to be displayed on PDP
 * @param {string} carouselHtml - Carousel HTML
 */
function createCarousel(imgs, thumbnails, fullImages, $productContainer, productVideoURL, productVideoPosition, carouselHtml) {
    var slickMainCarousel = $productContainer.find('.js-product-main-carousel');
    var slickThumbnailsMainCarousel = $productContainer.find('.js-slider-nav-thumbnails');
    var productImagesGrid = $productContainer.find('.product-images .row');
    var videoUrl = $('.js-image.js-video').data('url') || productVideoURL;
    var videoPosition = $('.js-image.js-video').data('position') || productVideoPosition;

    if ($(productImagesGrid).length > 0) {
        $(productImagesGrid).empty();
        for (var j = 0; j < imgs.length; j++) {
            if (j === 5) { break; }
            if (videoUrl !== null && videoPosition - 1 === (j)) {
                $(productImagesGrid).append($(`<div class="col-6 js-image js-video" data-slide="${j}"><iframe
                src="${videoUrl}&muted=1&background=1&autopause=0"
                class="d-block img-fluid product-images__image product_item_video-iframe"
                title="Vimeo video player"
                frameborder="0"
                allow="autoplay"
                allowfullscreen
            ></iframe></div>`));
            } else {
                $(productImagesGrid).append($(`<div class="col-6 js-image" data-url="${imgs[j].url}" data-slide="${j}"><img src="${imgs[j].url}" class="d-block img-fluid product-images__image" alt="${imgs[j].alt} image number ${parseInt(imgs[j].index, 10)}" title="${imgs[j].title}" itemprop="image" /></div>`));
            }
        }
    }

    if ($(slickMainCarousel).length > 0) {
        if ($(slickMainCarousel).hasClass('slick-initialized')) {
            $(slickMainCarousel).slick('unslick').empty();
        }

        if ($(slickThumbnailsMainCarousel).hasClass('slick-initialized')) {
            $(slickThumbnailsMainCarousel).slick('unslick');
        }

        $(slickMainCarousel).html(carouselHtml);

        if (imgs.length > 1) {
            pdpCarousel.createPDPCarousel($productContainer);
        }
    }
}

/**
 * Dynamically creates Bootstrap carousel from recommendation products
 * @param {Object[]} recommendations - Array of product recommendations
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createRecommendationsCarousel(recommendations, $productContainer) {
    var slickMainCarousel = $productContainer.find('.in-this-look .js-recommendation-carousel');
    if (slickMainCarousel.length > 0) {
        if ($(slickMainCarousel).hasClass('slick-initialized')) {
            $(slickMainCarousel).slick('unslick');
        }

        $productContainer.find('.in-this-look .js-recommendation-carousel').empty().html(recommendations);

        $(slickMainCarousel).slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            dots: false,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });
    }

    if (recommendations.length <= 4) {
        $('.in-this-look').addClass('d-none');
    } else {
        $('.in-this-look').removeClass('d-none');
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 * @param {boolean} isUpdatingColor - indicator if we're updating color attribute
 */
function handleVariantResponse(response, $productContainer, isUpdatingColor = false) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // updates the recommendations only when we change the color of the product
    if (isUpdatingColor) {
        // Generate product recommendations
        createRecommendationsCarousel(response.recommendations, $productContainer);
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    var imageThumbnails = response.product.images.small;
    var fullImages = response.product.fullImages.zoom;
    var productVideoURL = response.productVideoURL;
    var productVideoPosition = response.productVideoPosition;
    // updates the main imgs carousel only when we change the color of the product
    if (isUpdatingColor) {
        createCarousel(primaryImageUrls, imageThumbnails, fullImages, $productContainer, productVideoURL, productVideoPosition, response.carouselHtml);
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update discount tag
    var responseProductPrice = response.price;
    var $discountTag = $productContainer.find('.product-tile-prop__discount');

    if (responseProductPrice.list) {
        if ($discountTag.hasClass('d-none')) {
            $discountTag.removeClass('d-none');
        }
        var discountPercentage = Math.round(((responseProductPrice.sales.value - responseProductPrice.list.value) / responseProductPrice.list.value) * 100).toString() + '%';

        $discountTag.empty().html(discountPercentage);
    } else {
        $discountTag.addClass('d-none');
    }


    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    $('body').trigger('product:updateURL', { productUrl: response.URL });

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * Updates wishlist icon
 * @param {jQuery} $wishlistBtn - wishlist button DOM element
 * @param {string} pid - Product ID
 */
function updateWishlistStatus($wishlistBtn, pid) {
    const $icon = $wishlistBtn.find('i');
    const url = $wishlistBtn.attr('data-check');

    fetch(`${url}?pid=${pid}`, {
        method: 'GET'
    })
    .then(response => response.json())
    .then(
        data => {
            $wishlistBtn.attr('data-productid', `${pid}`);

            if (data.isInWishlist && $icon.hasClass('icon-heart-pdp')) {
                $icon.removeClass('icon-heart-pdp').addClass('icon-heart-pdp-hover');
                $wishlistBtn.addClass('js-remove-from-wish-list');
                $wishlistBtn.removeClass('js-add-to-wish-list');
            } else if (!data.isInWishlist && $icon.hasClass('icon-heart-pdp-hover')) {
                $icon.removeClass('icon-heart-pdp-hover').addClass('icon-heart-pdp');
                $wishlistBtn.addClass('js-add-to-wish-list');
                $wishlistBtn.removeClass('js-remove-from-wish-list');
            }
        }
    );
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {boolean} isUpdatingColor - indicator if we're updating color attribute
 */
function attributeSelect(selectedValueUrl, $productContainer, isUpdatingColor = false) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer, isUpdatingColor);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                let $wishlistBtn = $productContainer.find('.wishlist-button');
                if ($wishlistBtn.length > 0) {
                    updateWishlistStatus($wishlistBtn, data.product.id);
                }
                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 * @param {Object} button - add to cart button clicked on PLP nad PDP
 */
function handlePostCartAdd(response, button) {
    $('.minicart').trigger('count:update', response);

    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        var objShow = {
            show: true,
            button: button
        };
        var objHide = {
            show: false,
            timeOut: 3000
        };
        $('.minicart').trigger('cart:show', objShow);
        $('.minicart').trigger('cart:show', objHide);

        $('.minicart').trigger('cart:showMobile', response);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        },
        updateCartTotals: function (data) {
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.shipping-cost').empty().append(data.totals.totalShippingCost);
            $('.shipping-total-cost').empty().append(data.totals.totalShippingCost);
            $('.tax-total').empty().append(data.totals.totalTax);
            $('.grand-total-sum').empty().append(data.totals.grandTotal);
            $('.sub-total').empty().append(data.totals.subTotal);
            $('.minicart-quantity').empty().append(data.numItems).removeClass('d-none');
            $('.minicart__count').empty().append(data.resources.numberOfItems);
            $('.cart-items').empty().append(data.resources.numberOfItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            if (data.totals.orderLevelDiscountTotal.value > 0) {
                $('.order-discount').removeClass('hide-order-discount');
                $('.order-discount-total').empty()
                    .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
            } else {
                $('.order-discount').addClass('hide-order-discount');
            }

            if (data.totals.promoPrice !== 0) {
                $('.promo-price').removeClass('hide-promo');
                $('.promo-price__value').text(data.totals.promoPrice);
            } else {
                $('.promo-price').addClass('hide-promo');
            }

            if (data.totals.shippingLevelDiscountTotal.value > 0) {
                $('.shipping-discount').removeClass('hide-shipping-discount');
                $('.shipping-discount-total').empty().append('- ' +
                    data.totals.shippingLevelDiscountTotal.formatted);
            } else {
                $('.shipping-discount').addClass('hide-shipping-discount');
            }

            data.items.forEach(function (item) {
                if (data.totals.orderLevelDiscountTotal.value > 0) {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                }
                if (item.renderedPromotions) {
                    $('.item-' + item.UUID).empty().append(item.renderedPromotions);
                } else {
                    $('.item-' + item.UUID).empty();
                }
                $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
                $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
                $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
            });
        },
        updateApproachingDiscounts: function (approachingDiscounts) {
            var html = '';
            $('.approaching-discounts').empty();
            if (approachingDiscounts.length > 0) {
                approachingDiscounts.forEach(function (item) {
                    html += '<div class="single-approaching-discount text-center">'
                        + item.discountMsg + '</div>';
                });
            }
            $('.approaching-discounts').append(html);
        },
        validateBasket: function (data) {
            if (data.valid.error) {
                if (data.valid.message) {
                    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                        'fade show" role="alert">' +
                        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                        '<span aria-hidden="true">&times;</span>' +
                        '</button>' + data.valid.message + '</div>';

                    if ($('.cart-error').length === 0) {
                        $('.cart-error').removeClass('d-none');
                        $('.cart-error').append(errorHtml);
                    }
                } else {
                    $('.cart').empty().append('<div class="row"> ' +
                        '<div class="col-12 text-center sub-title-empty-cart"> ' +
                        '<h2>' + data.resources.emptyCartMsg + '</h2> ' +
                        '<h2>' + data.resources.emptyCartMsgTwo + '</h2> ' +
                            '<div class="sub-title-empty-cart-buttons">' +
                                '<a href="' + data.resources.womenCategoryUrl + '" class="btn btn-primary" title="' + data.resources.womenCategory + '">' + data.resources.womenCategory + '</a>' +
                                '<a href="' + data.resources.menCategoryUrl + '" class="btn btn-primary" title="' + data.resources.menCategory + '">' + data.resources.menCategory + '</a>' +
                            '</div>' +
                        '</div> ' +
                        '</div>'
                    );
                    $('.number-of-items').empty().append(data.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.numItems).removeClass('d-none');
                    $('.minicart__count').empty().append(data.resources.numberOfItems);
                    $('.cart-items').empty().append(data.resources.numberOfItems);
                    $('.minicart-link').attr({
                        'aria-label': data.resources.minicartCountOfItems,
                        title: data.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                }

                $('.checkout-btn').addClass('disabled');
            } else {
                $('.cart-error').addClass('d-none');
                $('.checkout-btn').removeClass('disabled');
            }
        },
        updateAvailability: function (data, uuid) {
            var lineItem;
            var messages = '';

            for (var i = 0; i < data.items.length; i++) {
                if (data.items[i].UUID === uuid) {
                    lineItem = data.items[i];
                    break;
                }
            }

            if (lineItem != null) {
                $('.availability-' + lineItem.UUID).empty();

                if (lineItem.availability) {
                    if (lineItem.availability.messages) {
                        lineItem.availability.messages.forEach(function (message) {
                            if (!lineItem.available) {
                                messages += '<p class="line-item-attributes">' + message + '</p>';
                            }
                        });
                    }

                    if (lineItem.availability.inStockDate) {
                        messages += '<p class="line-item-attributes line-item-instock-date">'
                            + lineItem.availability.inStockDate
                            + '</p>';
                    }
                }

                $('.availability-' + lineItem.UUID).html(messages);
            }
        }
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button, [data-attr="size"] button', function (e) {
            e.preventDefault();
            const isUpdatingColor = !$(this).data('attrValue');

            if ($(this).attr('disabled') || $(this).hasClass('selected')) {
                return;
            }
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            attributeSelect($(this).attr('data-url'), $productContainer, isUpdatingColor);
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        });
    },

    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect($(e.currentTarget).find('option:selected').data('url'),
                    $productContainer);
            }
        });
    },

    addToCart: function () {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () { // eslint-disable-line consistent-return
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var button = $(this);

            if ($(this).hasClass('disabled-btn')) {
                var $productError = $('.product-error');
                if ($productError.length === 0) {
                    if (!$('.swatch-value').hasClass('selected')) {
                        button.after('<div class="product-error">' + button.data('colorerror') + '</div>');
                    }

                    if (!$('.size-attribute').hasClass('selected')) {
                        button.after('<div class="product-error">' + button.data('error') + '</div>');
                    }
                }

                return false;
            }

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).find('.product-id').text(),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }

            addToCartUrl = getAddToCartUrl();

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(this))
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        if (data.error) {
                            $.spinner().stop();
                            if ($('.add-to-cart-messages').length === 0) {
                                $('body').append('<div class="add-to-cart-messages"></div>');
                            }
                            $('.add-to-cart-messages').append(
                                '<div class="alert alert-success add-to-basket-alert text-center"'
                                + ' role="alert">'
                                + data.message + '</div>'
                            );
                            setTimeout(function () {
                                $('.add-to-basket-alert').remove();
                            }, 3000);
                        } else {
                            button.html(button.data('addedToCart'));
                            setTimeout(function () {
                                $('body').trigger('product:afterAddToCart', data);
                                handlePostCartAdd(data, button);
                                miniCartReportingUrl(data.reportingURL);
                            }, 1500);
                            setTimeout(function () {
                                $.spinner().stop();
                                button.html(button.data('addToCart'));
                            }, 1500);
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                + '<div class="selected-pid row" '
                + 'data-pid="' + pid + '"'
                + 'data-qty="' + submittedQty + '"'
                + 'data-optionID="' + (optionID || '') + '"'
                + 'data-option-selected-value="' + (valueId || '') + '"'
                + '>'
                + '<div class="col-sm-11 col-9 bonus-product-name" >'
                + $choiceOfBonusProduct.find('.product-name').html()
                + '</div>'
                + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                + '</div>'
                ;
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption =
                    parseInt($(this)
                        .data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.minicart-quantity').html(data.totalQty);
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-success add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.msgSuccess + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                            if ($('.cart-page').length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    notifyMeButton: notifyMeButton,
    notifyMeForm: notifyMeForm
};

$(document).ready(function () {
    initPlpBannerLinkSwitch();
});
